import { render, staticRenderFns } from "./GlobalData.vue?vue&type=template&id=d37fa670"
import script from "./GlobalData.vue?vue&type=script&lang=js"
export * from "./GlobalData.vue?vue&type=script&lang=js"
import style0 from "./GlobalData.vue?vue&type=style&index=0&id=d37fa670&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports